"use strict";
//
// Copyright © 2020, 2021 Anticrm Platform Contributors.
// Copyright © 2021, 2025 Hardcore Engineering Inc.
// Copyright © 2026 Intabia Fusion.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkspaceAccountPermission = exports.SocialIdType = exports.IndexOrder = exports.roleOrder = exports.AccountRole = exports.DOMAIN_SEQUENCE = exports.DOMAIN_BLOB = exports.DOMAIN_COLLABORATOR = exports.DOMAIN_RELATION = exports.DOMAIN_TRANSIENT = exports.DOMAIN_MIGRATION = exports.DOMAIN_CONFIGURATION = exports.DOMAIN_SPACE = exports.DOMAIN_MODEL_TX = exports.DOMAIN_MODEL = exports.DateRangeMode = exports.ClassifierKind = exports.IndexKind = void 0;
exports.versionToString = versionToString;
exports.isActiveMode = isActiveMode;
exports.isDeletingMode = isDeletingMode;
exports.isArchivingMode = isArchivingMode;
exports.isMigrationMode = isMigrationMode;
exports.isRestoringMode = isRestoringMode;
exports.isUpgradingMode = isUpgradingMode;
/**
 * @public
 */
var IndexKind;
(function (IndexKind) {
    /**
     * Attribute with this index annotation should be added to elastic for search
     * Could be added to string or Ref attribute
     * TODO: rename properly for better code readability
     */
    IndexKind[IndexKind["FullText"] = 0] = "FullText";
    /**
     * For attribute with this annotation should be created an index in mongo database
     *
     * Also mean to include into Elastic search.
     */
    IndexKind[IndexKind["Indexed"] = 1] = "Indexed";
    // Same as indexed but for descending
    IndexKind[IndexKind["IndexedDsc"] = 2] = "IndexedDsc";
})(IndexKind || (exports.IndexKind = IndexKind = {}));
/**
 * @public
 */
var ClassifierKind;
(function (ClassifierKind) {
    ClassifierKind[ClassifierKind["CLASS"] = 0] = "CLASS";
    ClassifierKind[ClassifierKind["INTERFACE"] = 1] = "INTERFACE";
    ClassifierKind[ClassifierKind["MIXIN"] = 2] = "MIXIN";
})(ClassifierKind || (exports.ClassifierKind = ClassifierKind = {}));
// T Y P E S
/**
 * @public
 */
var DateRangeMode;
(function (DateRangeMode) {
    DateRangeMode["DATE"] = "date";
    DateRangeMode["TIME"] = "time";
    DateRangeMode["DATETIME"] = "datetime";
    DateRangeMode["TIMEONLY"] = "timeonly";
})(DateRangeMode || (exports.DateRangeMode = DateRangeMode = {}));
/**
 * @public
 */
exports.DOMAIN_MODEL = 'model';
/**
 * @public
 */
exports.DOMAIN_MODEL_TX = 'model_tx';
/**
 * @public
 */
exports.DOMAIN_SPACE = 'space';
/**
 * @public
 */
exports.DOMAIN_CONFIGURATION = '_configuration';
/**
 * @public
 */
exports.DOMAIN_MIGRATION = '_migrations';
/**
 * @public
 */
exports.DOMAIN_TRANSIENT = 'transient';
/**
 * @public
 */
exports.DOMAIN_RELATION = 'relation';
/**
 * @public
 */
exports.DOMAIN_COLLABORATOR = 'collaborator';
/**
 * Special domain to access s3 blob data.
 * @public
 */
exports.DOMAIN_BLOB = 'blob';
/**
 * @public
 */
exports.DOMAIN_SEQUENCE = 'sequence';
/**
 * @public
 */
var AccountRole;
(function (AccountRole) {
    AccountRole["ReadOnlyGuest"] = "READONLYGUEST";
    AccountRole["DocGuest"] = "DocGuest";
    AccountRole["Guest"] = "GUEST";
    AccountRole["User"] = "USER";
    AccountRole["Maintainer"] = "MAINTAINER";
    AccountRole["Owner"] = "OWNER";
    AccountRole["Admin"] = "ADMIN";
})(AccountRole || (exports.AccountRole = AccountRole = {}));
/**
 * @public
 */
exports.roleOrder = {
    [AccountRole.ReadOnlyGuest]: 5,
    [AccountRole.DocGuest]: 10,
    [AccountRole.Guest]: 20,
    [AccountRole.User]: 30,
    [AccountRole.Maintainer]: 40,
    [AccountRole.Owner]: 50,
    [AccountRole.Admin]: 100
};
/**
 * @public
 */
function versionToString(version) {
    return `${version?.major}.${version?.minor}.${version?.patch}`;
}
/**
 * @public
 */
var IndexOrder;
(function (IndexOrder) {
    IndexOrder[IndexOrder["Ascending"] = 1] = "Ascending";
    IndexOrder[IndexOrder["Descending"] = -1] = "Descending";
})(IndexOrder || (exports.IndexOrder = IndexOrder = {}));
function isActiveMode(mode) {
    return mode === 'active';
}
function isDeletingMode(mode) {
    return mode === 'pending-deletion' || mode === 'deleting' || mode === 'deleted';
}
function isArchivingMode(mode) {
    return (mode === 'archiving-pending-backup' ||
        mode === 'archiving-backup' ||
        mode === 'archiving-pending-clean' ||
        mode === 'archiving-clean' ||
        mode === 'archived');
}
function isMigrationMode(mode) {
    return (mode === 'migration-pending-backup' ||
        mode === 'migration-backup' ||
        mode === 'migration-pending-clean' ||
        mode === 'migration-clean');
}
function isRestoringMode(mode) {
    return mode === 'restoring' || mode === 'pending-restore';
}
function isUpgradingMode(mode) {
    return mode === 'upgrading';
}
var SocialIdType;
(function (SocialIdType) {
    SocialIdType["EMAIL"] = "email";
    SocialIdType["GITHUB"] = "github";
    SocialIdType["GOOGLE"] = "google";
    SocialIdType["PHONE"] = "phone";
    SocialIdType["OIDC"] = "oidc";
    SocialIdType["HULY"] = "huly";
    SocialIdType["TELEGRAM"] = "telegram";
    SocialIdType["HULY_ASSISTANT"] = "huly-assistant";
    SocialIdType["LOVE"] = "office";
})(SocialIdType || (exports.SocialIdType = SocialIdType = {}));
/**
 * @public
 */
var WorkspaceAccountPermission;
(function (WorkspaceAccountPermission) {
    /**
     * Allows users to import documents to workspace.
     */
    WorkspaceAccountPermission["ImportDocument"] = "ImportDocument";
})(WorkspaceAccountPermission || (exports.WorkspaceAccountPermission = WorkspaceAccountPermission = {}));
//# sourceMappingURL=classes.js.map